import React, { useEffect, useState } from 'react';
import { CouponChangeModalContainer } from './styles';
import { CommonButton } from '@Components';
import { getRewardCouponsList } from '@Redux/actions/dashboard';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../store.type';
import { Coupon, formatCouponData } from './utils';
import { selectTransactionReducer } from '@Redux/selectors';
import { saveCouponData } from '@Redux/actions/transaction';

interface CouponChangedModalProps {
  onClose: () => void;
  sourceAmount: number;
  sourceCurrency: string;
  destinationCurrency: string;
  renderCouponModal: (couponList: Coupon[]) => void;
}

const CouponChangedModal: React.FC<CouponChangedModalProps> = (props) => {
  const { onClose, sourceCurrency, sourceAmount, destinationCurrency, renderCouponModal } = props;
  const [couponList, setCouponList] = useState<Coupon[]>([]);
  const dispatch = useDispatch<AppDispatch>();
  const couponCMSData = useSelector(selectTransactionReducer)?.couponCMSData;
  const { sourceErr, DestinationErr } =
    useSelector(selectTransactionReducer)?.currencyCovertor || {};

  const { heading, description, primaryCTA, secondaryCTA } =
    couponCMSData?.couponClearedModal || {};

  const getCouponList = async () => {
    const couponList = await dispatch(getRewardCouponsList({ source_currency: sourceCurrency }));
    if (couponList?.data?.success) {
      const formattedCouponData =
        formatCouponData(couponList.data.data || [], sourceAmount, destinationCurrency) || [];
      setCouponList(formattedCouponData);
      dispatch(saveCouponData(formattedCouponData));
    }
  };

  useEffect(() => {
    if (sourceCurrency) getCouponList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceCurrency]);

  const handleShowCouponsAndClose = async () => {
    // First show the coupons modal by calling renderCouponModal function of CurrencyConverter
    renderCouponModal && couponList && renderCouponModal(couponList);
    // Then close the current modal
    onClose();
  };

  return (
    <CouponChangeModalContainer>
      <div className="heading">{heading}</div>
      <div className="description">{description}</div>

      <div className="got-it-container">
        <CommonButton text={primaryCTA} onClick={onClose} />
      </div>
      {couponList?.length > 0 && !sourceErr && !DestinationErr ? (
        <div className="secondary-container">
          <CommonButton type="link" text={secondaryCTA} onClick={handleShowCouponsAndClose} />
        </div>
      ) : null}
    </CouponChangeModalContainer>
  );
};

export default CouponChangedModal;
